import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorDeposit = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      d="M3.632 5.496a2.25 2.25 0 0 0-1.733 2.669l1.35 6.356V18.5a2.25 2.25 0 0 0 2.25 2.25h13a2.25 2.25 0 0 0 2.25-2.25v-9a2.25 2.25 0 0 0-2.25-2.25h-.948l-.49-2.308a2.25 2.25 0 0 0-2.67-1.733L3.633 5.496ZM16.017 7.25H5.5a2.25 2.25 0 0 0-2.002 1.222l-.132-.619a.75.75 0 0 1 .578-.89l10.76-2.286a.75.75 0 0 1 .89.577l.423 1.996ZM4.75 9.5a.75.75 0 0 1 .75-.75h13a.75.75 0 0 1 .75.75v9a.75.75 0 0 1-.75.75h-13a.75.75 0 0 1-.75-.75v-9Z"
    />
    <path
      fill="#F7A600"
      d="M15.469 10.914a.75.75 0 0 1 .117 1.055L14.56 13.25H23a.75.75 0 0 1 0 1.5h-8.44l1.026 1.282a.75.75 0 0 1-1.172.936L12.04 14l2.374-2.969a.75.75 0 0 1 1.055-.117Z"
    />
  </svg>
);
export default SvgTwoColorDeposit;
